import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import ActionText from '../../core/ActionText';
import { globalStyles } from '../../core/style/gstheme';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import { UserConsumer } from '../providers/UserProvider';
import AddDiscussionItemDialog from './AddDiscussionItemDialog';
import DiscussionItem from './DiscussionItem';
import { ENTITLEMENTS } from '../../application-core/constants';

const styles = theme => {
    return Object.assign({
        suggestionText: {
            color: theme.palette.primary.main,
            fontSize: 16,
            lineheight: '22px',
            fontWeight: 500,
            marginTop: 12
        }
    }, globalStyles);
};

class DiscussionViewer extends React.Component {

    addDiscussionItem = (user) => async (lang, text) => {
        const iriID = uuidv4();
        const itemIRI = "https://grafsync.graphifi.com/data/discussionitem/" + iriID;
        let newItem = {
            id: itemIRI,
            type: "DiscussionItem",
            user: user.id,
            comment: { [lang]: text }
        };
        await GS.insertResource(newItem, itemIRI, this.props.graph);
        GS.insert(this.props.id, this.props.graph, "hasDiscussionThread", itemIRI);
    };

    render() {

        const { data, graph, users, classes, defaultLang, active, isReadOnly, displayNoComments, entitlements } = this.props;

        if (isReadOnly && !data.hasDiscussionThread && displayNoComments) {
            return <ActionText>No comments.</ActionText>;
        }

        return (
            <UserConsumer>
                {({ user }) =>
                    <div data-test="discussion-viewer">
                        {data.hasDiscussionThread && data.hasDiscussionThread.length > 0 &&
                            <div>
                                <div data-test="comment-count" className={classes.suggestionText} style={{ marginBottom: 12, borderTop: 'solid 1px #EEEEEE', paddingTop: 12 }}>Comments ({data.hasDiscussionThread.length})</div>
                                <div data-test="discussion-comments">
                                    {data.hasDiscussionThread.map((discussionItem, index) =>
                                        <div key={discussionItem} style={index !== 0 ? { borderTop: 'solid 1px #EEEEEE', paddingTop: 12 } : {}}>
                                            <DiscussionItem defaultLang={defaultLang} id={discussionItem} graph={graph} users={[user, ...users]} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        {(!data.hasDiscussionThread || data.hasDiscussionThread.length === 0) && !entitlements.includes(ENTITLEMENTS.CREATE_DISCUSSION) &&
                            <ActionText>No comments.</ActionText>
                        }
                        {!isReadOnly && active &&
                            (entitlements.includes(ENTITLEMENTS.CREATE_DISCUSSION)
                                || entitlements.includes(ENTITLEMENTS.CREATE_TASK)) &&
                            <div style={{ borderTop: 'solid 1px #EEEEEE' }}>
                                <AddDiscussionItemDialog
                                    defaultLang={defaultLang}
                                    onAddItem={this.addDiscussionItem(user)} />
                            </div>
                        }
                    </div>
                }
            </UserConsumer>
        );
    }
}

DiscussionViewer.defaultProps = {
    active: true,
    isRequired: false,
    displayNoComments: false,
    initialComment: true
};

DiscussionViewer.propTypes = {
    defaultLang: PropTypes.string.isRequired,
    entitlements: PropTypes.array,
    active: PropTypes.bool,
    displayNoComments: PropTypes.bool,
    classes: PropTypes.object,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
    isReadOnly: PropTypes.bool
};

export default withStyles(styles)(withGS(DiscussionViewer, ["ALL"], null, {}));